
export function generateEquipmentList(items) {
    return items.map(item => {
        return {
            name: item.equipment.name,
            quantity: item.sentQuantity,
            requestedQuantity: item.requestedQuantity,
        }
    })
}

export function calculateTotalWeight(items) {
    let totalWeight = 0

    items.forEach(item => {
        totalWeight += item.requestedQuantity * item.equipment.itemWeightInLbs
    })

    return totalWeight.toFixed(0)
}

export function generatePages(columns, maxColumnsPerPage = 4) {

    console.info(columns)

    let pages = { 1: []}
    let currentPage = 1

    Object.keys(columns).forEach(columnKey => {
        const column = columns[columnKey]
        console.info("-----------------")
        console.info(column)
        if(pages[currentPage].length == maxColumnsPerPage) {
            currentPage++ 
            pages[currentPage] = [] 
        }
        pages[currentPage].push(column)
    })

    return pages
}

export function generateColumns(items, maxItemsPerColumn = 15) {
    let columns = {
        1: [],
        2: [],
        3: [],
    }

    let categories = {}

    // generate all categories
    items.forEach(item => {

        // set the category
        if(item.equipment.category){
            // equipment with a category

            if(item.equipment.category.id in categories){
                // if that category is already in the
                categories[item.equipment.category.id].items.push({...item})
            } else {
                categories[item.equipment.category.id] = {
                    name: item.equipment.category.name,
                    items: [{...item}]
                }
            }
        } else {
            // equipment with no category
            if("0" in categories){
                categories["0"].items.push({...item})
            } else {
                categories["0"] = {
                    name: "No Category",
                    items: [{...item}]
                }
            }
        }
        
    })

    // decide on which items go into which column
    let columnTotals = {
        1: 0,
        2: 0,
        3: 0
    }

    let currentColumn = 1

    Object.keys(categories).forEach(categoryKey => {
        const category = categories[categoryKey]

        // check the total in the current column
        if(columnTotals[currentColumn] >= maxItemsPerColumn - 1) {
            currentColumn += 1

            // check if that column # is in the columns object
            if(!(currentColumn in columns)){
                columns[currentColumn] = []
                if(!(currentColumn in columnTotals)) {
                    columnTotals[currentColumn] = 0
                }
            }
        }

        // add the category item
        columns[currentColumn].push({
            type: "category",
            value: category["name"]
        })
        columnTotals[currentColumn] += 1

        // check if that column # is in the columns object
        if(!(currentColumn in columns)){
            columns[currentColumn] = []
            if(!(currentColumn in columnTotals)) {
                columnTotals[currentColumn] = 0
            }
        }

        // add the items for the category
        category.items.forEach(item => {

            // check the total in the current column
            if(columnTotals[currentColumn] >= maxItemsPerColumn) {
                currentColumn += 1

                // check if that column # is in the columns object
                if(!(currentColumn in columns)){
                    columns[currentColumn] = []
                    if(!(currentColumn in columnTotals)) {
                        columnTotals[currentColumn] = 0
                    }
                }

                // if it's a new column, add the category for the item at the top first
                columns[currentColumn].push({
                    type: "category",
                    value: category["name"]
                })
                columnTotals[currentColumn] += 1
            }

            columns[currentColumn].push({
                type: "item",
                value: {...item}
            })
            columnTotals[currentColumn] += 1
        })
    })
    
    return columns
}